import { useErrorNotificationApi } from '@equifinance/shared';
import { Search } from '../types/Search';
import { AvmSearchTypes, Checklist } from '../contexts/checklist';

const apiPath = `${process.env.REACT_APP_ORIGINATION_API_PATH}/`;

const apiUrl = (path: string) => `${apiPath}${path}`;

export type IntermediateApiType = {
  getLandRegistrySearch: (applicationId: string) => Promise<Search>,
  getAVMSearch: (applicationId: string) => Promise<Search>,
  getSearches: (applicationId: string) => Promise<Search[]>,
  postAVMSearch: (applicationId: string, avmType: AvmSearchTypes) => Promise<Checklist>,
}

export default function useSearchApi(): IntermediateApiType {
  const { get, post } = useErrorNotificationApi(apiUrl);
  return {
    getLandRegistrySearch: (applicationId: string) => get(`landregistry/initiate-and-get-status/${applicationId}`),
    getAVMSearch: (applicationId: string) => get(`automaticvaluation/initiate-and-get-status/${applicationId}`),
    getSearches: (applicationId: string) => get(`searches/search-status/${applicationId}`),
    postAVMSearch: (applicationId: string, avmType: AvmSearchTypes) => post(`searches/avm/${applicationId}`, { avmType }),
  };
}
